var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"hidden","name":_vm.id},domProps:{"value":_vm.content}}),_vm._v(" "),_c('vue-editor',{attrs:{"id":_vm.id,"name":_vm.id,"editorToolbar":_vm.customToolbar},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }